import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import useQuery from 'Hooks/query.hook';
import { useTranslation } from 'react-i18next';
import { decode } from 'Helpers/enc';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { Button } from '@life-line-lab/components-react';

interface SuccessViewProps {}

const SuccessView: React.FC<SuccessViewProps> = () => {
  const history = useHistory();
  const query = useQuery();
  const ref = query.get('ref');
  const { t } = useTranslation();

  const handleClick = () => {
    if (ref) {
      window.location.href = decode(ref);
    }
    else {
      history.push('/login')
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.registrationSuccess')}</title>
      </Helmet>

      <div className="success-view">
        <Space className="success-view--inner center" direction="vertical" size="large">
          <img src="/assets/images/success.svg" />

          <h1 className="title-header">
            {t("title.registrationSuccess")}
          </h1>

          <div dangerouslySetInnerHTML={{ __html: t('txt.registrationSuccess')}} />

          <div className="form--actions center">
            <Button
              type="primary"
              label={
                <React.Fragment>
                  <span>{t('action.goToLogin')}</span> <ArrowRightOutlined />
                </React.Fragment>
              }
              size="large"
              onClick={handleClick}
            />
          </div>
        </Space>
      </div>
    </React.Fragment>
  )
}

export default SuccessView;
